<template>
	<div class="page-company page-content" v-loading="body_loading">
		<div class="main-body">
			<el-row class="hd">
				<el-col :span="12">
					<h3 style="float: none;">店铺管理</h3>
					<div class="flex-block breadcrumb-box">
						<div class="position-text">位置：</div>
						<el-breadcrumb separator-class="el-icon-arrow-right">
							<el-breadcrumb-item>客户管理</el-breadcrumb-item>
							<el-breadcrumb-item>店铺管理</el-breadcrumb-item>
						</el-breadcrumb>
					</div>
				</el-col>
				<el-col :span="12" class="text-right" style="padding: 11px 24px 11px 0;">
					<el-button type="primary" class="btn-bg-p" @click="handleCompany('add')">添加 <i
							class="el-icon-plus"></i></el-button>
					<el-button type="primary" class="btn-bg-r" @click="delmultiple()">批量删除</el-button>
				</el-col>
			</el-row>
			<div class="bd">
				<div class="search-block content-body">
					<el-form :inline="true" ref="formSearch" :model="form_search" class="demo-form-inline"
						@submit.native.prevent>
						<el-form-item prop="name" label="店铺名称：" style="margin-bottom: 0;">
							<el-input v-model="form_search.name" size="small" placeholder="店铺名称" clearable></el-input>
						</el-form-item>
						<el-form-item prop="type" label="类型：">
							<el-select size="small" v-model="form_search.type" placeholder="请选择" style="width:100%;">
								<el-option v-for="item in init_data.type_list" :key="item.id" :label="item.name"
									:value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item prop="status" label="状态：">
							<el-select size="small" v-model="form_search.status" placeholder="请选择" style="width:100%;">
								<el-option v-for="item in init_data.status_list" :key="item.id" :label="item.name"
									:value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item style="margin-bottom: 0;">
							<el-button type="primary" class="search-btn" size="medium" @click='searchList()'>查询
							</el-button>
						</el-form-item>
					</el-form>
				</div>
				<div class="table-block content-body">
					<div ref="contentBody">
						<el-table ref="multipleTable" :data="table_data.list" v-loading="table_data.loading"
							tooltip-effect="dark" style="width: 100%;text-align: center;"
							@selection-change="handleSelectionChange">
							<el-table-column type="selection" width="55"></el-table-column>
							<el-table-column prop="id" width="55" label="ID" align="center"></el-table-column>
							<el-table-column prop="logo_url" align="center" label="logo" min-width="120">
								<template slot-scope="scope">
									<img class="cursor" :src="baseUrl + scope.row.logo_url" height="23"
										@click="dlg_preview.img_url = baseUrl + scope.row.logo_url;dlg_preview.visible = true;"
										title="点击查看" />
								</template>
							</el-table-column>
							<el-table-column prop="number" align="center" label="店铺编码" min-width="140">
							</el-table-column>
							<el-table-column prop="name" align="center" label="店铺名称" min-width="180">
								<template slot-scope="scope">
									<my-textEllipsis v-if="is_refresh" :content="scope.row.name"></my-textEllipsis>
								</template>
							</el-table-column>
							<el-table-column prop="mobile" align="center" label="店铺电话" min-width="140">
							</el-table-column>
							<el-table-column prop="addr" align="center" label="店铺地址" min-width="180">
								<template slot-scope="scope">
									<my-textEllipsis v-if="is_refresh" :content="scope.row.addr"></my-textEllipsis>
								</template>
							</el-table-column>
							<el-table-column prop="remark" align="center" label="公告" width="180">
								<template slot-scope="scope">
									<my-textEllipsis v-if="is_refresh" :content="scope.row.remark"></my-textEllipsis>
								</template>
							</el-table-column>
							<el-table-column prop="score" align="center" label="评分" min-width="140">
							</el-table-column>
							<el-table-column prop="sort" align="center" label="排序" min-width="140">
							</el-table-column>
							<el-table-column prop="type_name" align="center" label="类型" min-width="120">
								<template slot-scope="scope">
									<span :class="'status-'+scope.row.type">{{scope.row.type_name}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="status_name" align="center" label="状态" min-width="120">
								<template slot-scope="scope">
									<span :class="'status-'+scope.row.status">{{scope.row.status_name}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="operating" align="center" label="操作" min-width="140" fixed="right">
								<template slot-scope="scope">
									<el-button class="option-btn btn-bd-s" type="primary" size="mini"
										@click="handleCompany('edit',scope.row)">编辑</el-button>
									<!-- <el-button class="option-btn btn-bd-o" type="primary" size="mini" @click="$util.goTo('/customer/addrlist',{query:{desk_number:scope.row.number}})">人员</el-button> -->
									<el-button class="option-btn btn-bd-r" type="primary" size="mini"
										@click="deleteCompany(scope.row.id)">删除</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="table_data.page_info.page" :page-sizes="[10,30, 50,80,100]"
						:page-size="table_data.page_info.pageSize" layout="total, sizes, prev, pager, next"
						:total="table_data.page_info.total">
					</el-pagination>
				</div>
			</div>
		</div>
		<el-dialog class="dialog-export company-dialog" :title="dlg_company.title" :visible.sync="dlg_company.visible"
			width="534px" @closed="closeCompany" :close-on-click-modal="false">
			<el-form ref="formCompany" :model="dlg_company.form" label-width="110px" :rules="dlg_company.rules"
				@submit.native.prevent>
				<el-form-item prop="name" style="margin-top: 15px;" label="店铺名称：" :error="dlg_company.error.name">
					<el-input size="small" v-model="dlg_company.form.name" placeholder='请输入店铺名称' clearable></el-input>
				</el-form-item>
<!-- 				<el-form-item prop="nav_ids" label="所属类目：" :error="dlg_company.error.nav_ids">
					<el-select size="small" v-model="dlg_company.nav_ids" multiple placeholder="请选择"
						style="width: 100%;" @change="changeSelect">
						<el-option v-for="item in dlg_company.init_data.nav_list" :key="item.id" :label="item.name"
							:value="item.id">
						</el-option>
					</el-select>
				</el-form-item> -->
				<el-form-item prop="mobile" style="margin-top: 15px;" label="店铺电话：" :error="dlg_company.error.mobile">
					<el-input size="small" v-model="dlg_company.form.mobile" placeholder='请输入店铺电话' clearable></el-input>
				</el-form-item>
				<el-form-item prop="addr" label="店铺详细地址：">
					<el-input size="small" v-model="dlg_company.form.addr" placeholder='请输入店铺详细地址' clearable></el-input>
				</el-form-item>
				<el-form-item prop="latitude" label="腾讯地图纬度：">
				    <el-input size="small" v-model="dlg_company.form.latitude" placeholder='请输入纬度' clearable></el-input>
				</el-form-item>
				<el-form-item prop="longitude" label="腾讯地图经度：">
				    <el-input size="small" v-model="dlg_company.form.longitude" placeholder='请输入经度' clearable></el-input>
				</el-form-item>
				<!-- logo -->
				<el-form-item prop="logo_url" style="margin-top: 15px;" label="logo："
					:error="dlg_company.error.logo_url">
					<el-upload :action="dlg_company.params.action" :headers="dlg_company.params.headers"
						:data="dlg_company.params.data" accept="image/png,image/jpeg,image/jpg"
						:class="dlg_company.logo_hide_upload?'hide-upload head-upload':'head-upload'"
						list-type="picture-card" :file-list="dlg_company.logo_list" name="file"
						:on-preview="(file) => {dlg_preview.logo_url = file.url;dlg_preview.visible = true;}"
						:on-remove="removeLogoImg" :on-success="uploadSuccessLogoImg">
						<i class="el-icon-plus"></i>
					</el-upload>
					<p class="img-tips">图片尺寸：240px*240px（请上传小于1M的图片）</p>
				</el-form-item>
				<!-- 门头 -->
				<el-form-item prop="image_url" style="margin-top: 15px;" label="门头图："
					:error="dlg_company.error.image_url">
					<el-upload :action="dlg_company.params.action" :headers="dlg_company.params.headers"
						:data="dlg_company.params.data" accept="image/png,image/jpeg,image/jpg"
						:class="dlg_company.hide_upload?'hide-upload head-upload':'head-upload'"
						list-type="picture-card" :file-list="dlg_company.img_list" name="file"
						:on-preview="(file) => {dlg_preview.img_url = file.url;dlg_preview.visible = true;}"
						:on-remove="removeImg" :on-success="uploadSuccessImg">
						<i class="el-icon-plus"></i>
					</el-upload>
					<p class="img-tips">图片尺寸：750px*300px（请上传小于1M的图片）</p>
				</el-form-item>
				<!-- banner -->
				<el-form-item prop="banner_urls" style="margin-top: 15px;" label="Banner图：">
					<el-upload class="upload-demo" :action="dlg_company.params.action"
						:headers="dlg_company.params.headers" 
						:data="dlg_company.params.data"
						accept="image/png,image/jpeg,image/jpg"
						:on-preview="(file) => {dlg_preview.img_url = file.url;dlg_preview.visible = true;}" 
						:on-remove="handleBannerRemove"
						:on-success="handleBannerSuccess"
						:file-list="dlg_company.banner_list" 
						:limit="3" 
						list-type="picture-card">
						<el-button size="small" type="primary">点击上传</el-button>
					</el-upload>
					<p class="img-tips">图片尺寸：750px*300px（请上传小于1M的图片）最多3个</p>
				</el-form-item>
				<el-form-item prop="remark" label="公告：">
					<el-input v-model="dlg_company.form.remark" type="textarea" :rows="3" size="small"
						placeholder="请输入备注"></el-input>
				</el-form-item>
				<el-form-item prop="score" label="评分：">
					<el-input v-model="dlg_company.form.score" type="text" :rows="3" size="small" placeholder="请输入店铺评分">
					</el-input>
				</el-form-item>
				<el-form-item prop="low_consumption" label="人均消费：">
					<el-input v-model="dlg_company.form.low_consumption" type="text" :rows="3" size="small" placeholder="请输入人均消费">
					</el-input>
				</el-form-item>
				<el-form-item prop="sort" label="排序：">
					<el-input v-model="dlg_company.form.sort" type="number" :rows="3" size="small" placeholder="请输入序号">
					</el-input>
				</el-form-item>
				<el-form-item prop="type" label="类型：">
					<el-radio-group v-model="dlg_company.form.type">
						<el-radio v-for="(item, index) in dlg_company.init_data.type_list" :key="index"
							:label="item.id">{{item.name}}</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item prop="status" label="状态：">
					<el-radio-group v-model="dlg_company.form.status">
						<el-radio v-for="(item, index) in dlg_company.init_data.status_list" :key="index"
							:label="item.id">{{item.name}}</el-radio>
					</el-radio-group>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dlg_company.visible = false">取 消</el-button>
				<el-button type="primary" @click="submitCompany()" :loading="dlg_company.btn_loading">确认</el-button>
			</span>
		</el-dialog>
		<el-dialog :visible.sync="dlg_preview.visible" class="dialog-no-title text-center" width="420px">
			<img width="100%" :src="dlg_preview.img_url" style="max-width:100%;">
		</el-dialog>
	</div>
</template>
<script>
	export default {
		name: 'usercenter',
		data() {
			var valiImg = (rule, value, callback) => {
				if (!this.dlg_company.hide_upload) {
					callback(new Error("请上传门头图"));
				} else {
					callback();
				}
			};
			var valiLogoImg = (rule, value, callback) => {
				if (!this.dlg_company.logo_hide_upload) {
					callback(new Error("请上传门头图"));
				} else {
					callback();
				}
			};
			return {
				drawer: false,
				clientHeight: '',
				body_loading: false,
				is_refresh: true,
				baseUrl: this.$client.IMG_URL,
				timestamp: new Date().getTime(),
				//搜索
				form_search: {
					//id: "",
					name: "",
					status: -1,
					type: -1
				},
				init_data: {
					type_list: [],
					status_list: [],
				},
				multipleSelection: [],
				table_data: {
					loading: false,
					list: [],
					page_info: {
						page: 1,
						pageSize: 30,
						total: 30
					}
				},
				dlg_company: {
					id: '',
					visible: false,
					btn_loading: false,
					api: '',
					title: '',
					img_list: [],
					banner_list: [],
					form_banner_list: [],
					logo_list: [],
					nav_ids: [],
					form: {
						type: 1,
						name: '',
						mobile: '',
						addr: '',
						latitude:'',
						longitude:'',
						logo_url: '',
						image_url: '',
						banner_urls: '',
						nav_ids: '',
						remark: '',
						low_consumption: 0.0,
						score: 5.0,
						sort: 99,
						status: 1
					},
					error: {
						name: '',
						logo_url: '',
						image_url: '',
					},
					reset_form: {},
					init_data: {
						nav_list: [],
						type_list: [],
						status_list: []
					},
					rules: {
						name: {
							required: true,
							message: '请输入店铺名称',
							trigger: ['change', 'blur']
						},
						logo_url: {
							required: true,
							validator: valiLogoImg
						},
						image_url: {
							required: true,
							validator: valiImg
						},
						type: {
							required: true,
							message: '请选择类型',
							trigger: ['change', 'blur']
						},
						status: {
							required: true,
							message: '请选择状态',
							trigger: ['change', 'blur']
						},
						nav_ids: {
							required: true,
							message: '请输入选择类目',
							trigger: ['change', 'blur']
						},
					},
					params: {
						action: this.$client.API_URL + '/adminapi/upload/images',
						data: {
							path: 'desk'
						},
						headers: {
							token: localStorage.getItem('token')
						}
					}
				},
				dlg_preview: {
					visible: false,
					img_url: ''
				}
			}
		},
		created() {
			document.title = '店铺管理';
			this.dlg_company.reset_form = Object.assign({}, this.dlg_company.form);
			this.getList();
		},
		methods: {
			searchList() {
				var _this = this;
				_this.table_data.page_info.page = 1;
				_this.getList();
			},
			getList() {
				var _this = this;
				var params = _this.form_search;
				params.p = _this.table_data.page_info.page;
				params.pageSize = _this.table_data.page_info.pageSize;
				_this.table_data.loading = true;
				var status_list = [{
					id: -1,
					name: '全部'
				}];
				var nav_list = [{
					id: -1,
					name: '不选'
				}];
				this.$client.get('/adminapi/desk/list', params, function(res, message) {
					_this.table_data.list = res.list;
					_this.table_data.page_info = res.pager;
					_this.dlg_company.init_data.nav_list = res.nav_name_list;
					_this.dlg_company.init_data.type_list = res.type_name_list;
					_this.dlg_company.init_data.status_list = res.status_name_list;
					_this.init_data.type_list = status_list.concat(res.type_name_list);
					_this.init_data.status_list = status_list.concat(res.status_name_list);
					_this.table_data.loading = false;
				}, function(res) {
					_this.table_data.loading = false;
				});
			},
			handleSizeChange(val) {
				//console.log(`每页 ${val} 条`);
				this.table_data.page_info.pageSize = val;
				this.getList();
			},
			handleCurrentChange(val) {
				//console.log(`当前页: ${val}`);
				this.table_data.page_info.page = val;
				this.getList();
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			uploadSuccessLogoImg(res, file, fileList) {
				this.dlg_company.logo_list = fileList;
				this.dlg_company.form.logo_url = res.data.file_url;
				this.dlg_company.logo_hide_upload = true;
			},
			removeLogoImg(file, fileList) {
				this.dlg_company.form.logo_url = '';
				this.dlg_company.logo_list = [];
				this.dlg_company.logo_hide_upload = false;
			},
			uploadSuccessImg(res, file, fileList) {
				this.dlg_company.img_list = fileList;
				this.dlg_company.form.image_url = res.data.file_url;
				this.dlg_company.hide_upload = true;
			},
			removeImg(file, fileList) {
				this.dlg_company.form.image_url = '';
				this.dlg_company.img_list = [];
				this.dlg_company.hide_upload = false;
			},
			delmultiple() {
				var _this = this;
				var mullist = this.multipleSelection;
				if (mullist.length == 0) {
					_this.$message("请勾选需要删除的店铺");
					return;
				}
				var idList = [];
				for (var i = 0; i < mullist.length; i++) {
					idList.push(mullist[i].id);
				}
				var params = {
					id: idList.join(",")
				}
				this.$confirm('确定要批量删除？', "", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						iconClass: "icon-delete el-icon-delete",
						customClass: "my-confirm-box",
						center: true,
					})
					.then(() => {
						_this.$client.post('/adminapi/desk/delete', params, function(res, message) {
							_this.getList();
						}, function(res) {

						});
					})
					.catch(() => {});
			},
			handleCompany(type, data) {
				this.dlg_company.visible = true;
				if (type == 'add') {
					this.dlg_company.title = '添加店铺';
					this.dlg_company.api = '/adminapi/desk/save';
				} else {
					this.dlg_company.id = data.id;
					this.dlg_company.title = '编辑店铺';
					this.dlg_company.nav_ids = this.$util.changeSelect(data.nav_ids);
					this.dlg_company.form.nav_ids = data.nav_ids;
					if (data) {
						for (var key in this.dlg_company.form) {
							this.dlg_company.form[key] = data[key];
						}
						// 初始化logo
						if (data.logo_url) {
							this.dlg_company.logo_list = [{
								name: 'logo图',
								url: this.baseUrl + data.logo_url
							}];
							this.dlg_company.logo_hide_upload = true;
						} else {
							this.dlg_company.logo_list = [];
							this.dlg_company.logo_hide_upload = false;
						}
						// 初始化店铺主图
						if (data.image_url) {
							this.dlg_company.img_list = [{
								name: '门头图',
								url: this.baseUrl + data.image_url
							}];
							this.dlg_company.hide_upload = true;
						} else {
							this.dlg_company.img_list = [];
							this.dlg_company.hide_upload = false;
						}
						// 初始化banner图
						if (data.banner_urls){
							this.dlg_company.banner_list = [];
							this.dlg_company.form_banner_list = data.banner_urls.substr(0, data.banner_urls.length - 1).split(';');
							for(let i in this.dlg_company.form_banner_list){
								this.dlg_company.banner_list.push({
									'name' : i,
									'url' : this.baseUrl + this.dlg_company.form_banner_list[i]
								});
							}
						} else {
							this.dlg_company.banner_list = [];
							this.dlg_company.form_banner_list = [];
						}
					}
					this.dlg_company.api = '/adminapi/desk/save?id=' + data.id;
				}
			},
			deleteCompany(id) {
				var _this = this;
				this.$confirm('确定要删除？', "", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						iconClass: "icon-delete el-icon-delete",
						customClass: "my-confirm-box",
						center: true,
					})
					.then(() => {
						_this.$client.post('/adminapi/desk/delete', {
							id: id
						}, function(res, message) {
							_this.getList();
						}, function(res) {

						});
					})
					.catch(() => {});
			},
			submitCompany() {
				var _this = this;
				_this.$refs['formCompany'].validate((valid) => {
					if (valid) {
						this.dlg_company.btn_loading = true;
						// 处理banner数据封装
						this.dlg_company.form.banner_urls = '';
						if(this.dlg_company.form_banner_list.length > 0){
							for(let i in this.dlg_company.form_banner_list){
								this.dlg_company.form.banner_urls = this.dlg_company.form.banner_urls + this.dlg_company.form_banner_list[i] + ';';
							}
						}
						// 提交数据
						this.$client.post(this.dlg_company.api, this.dlg_company.form, function(res, message) {
							_this.$message(message);
							_this.getList();
							_this.dlg_company.btn_loading = false;
							_this.dlg_company.visible = false;
						}, function(message) {
							_this.dlg_company.btn_loading = false;
							if ((typeof message) === 'object') {
								for (var key in message) {
									_this.dlg_company.error[key] = message[key];
								}
							}
						});
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			closeCompany() {
				for (var key in this.dlg_company.form) {
					this.dlg_company.form[key] = this.dlg_company.reset_form[key];
				}
				this.$nextTick(() => {
					this.$refs.formCompany.clearValidate();
				})
			},
			changeSelect(val) {
				this.dlg_company.form.nav_ids = val.toString();
			},
			changeFixed(clientHeight) {
				this.$refs.contentBody.style.minHeight = (clientHeight - 394) + 'px';
			},
			handleBannerSuccess(response, file, fileLis){
				this.dlg_company.banner_list.push({'name' : response.data.file_id, 'url' : this.baseUrl + response.data.file_url});
				this.dlg_company.form_banner_list.push([response.data.file_url]);
			},
			handleBannerRemove(file, banner_list) {
				var rm_url = file['url'];
				var arr = [];
				var form_arr = [];
				if(this.dlg_company.banner_list.length){
					for(let i in this.dlg_company.banner_list){
						if(rm_url != this.dlg_company.banner_list[i]['url']){
							arr.push(this.dlg_company.banner_list[i]);
							form_arr.push(this.dlg_company.banner_list[i]['url'].replace(this.baseUrl, ''));
						}
					}
				}
				this.dlg_company.banner_list = arr;
				this.dlg_company.form_banner_list = form_arr;
			},
		},
		mounted() {
			// 获取浏览器可视区域高度
			this.clientHeight = `${document.documentElement.clientHeight}` //document.body.clientWidth;
			//console.log(self.clientHeight);
			window.onresize = function temp() {
				this.clientHeight = `${document.documentElement.clientHeight}`;
			};
		},
		watch: {
			// 如果 `clientHeight` 发生改变，这个函数就会运行
			clientHeight: function() {
				this.changeFixed(this.clientHeight)
			}
		}
	}
</script>
<style>
	.page-company .el-upload--picture-card {
		line-height: 80px;
	}

	.page-company .el-upload--picture-card,
	.el-upload-list--picture-card .el-upload-list__item {
		width: 80px;
		height: 80px;
	}

	.hide-upload .el-upload--picture-card {
		display: none;
	}
</style>
<style scoped>


</style>
